import React from "react";
import PropTypes from "prop-types";
import * as formViews from "./constants/formViews";
import ConnectedResetPasswordConfirmation from "./ConnectedResetPasswordConfirmation";
import ConnectedAccountFormContent from "./ConnectedAccountFormContent";

const AccountForm = ({ formView }) => {
    // If the view has been updated to the view that contains the reset
    // password confirmation screen that is displayed after the successful
    // completion of the request sent by clicking the "Need help with
    // password" button
    if (formView === formViews.SEND_RESET_PASSWORD_EMAIL_CONFIRMATION) {
        return <ConnectedResetPasswordConfirmation />;
    }

    return <ConnectedAccountFormContent />;
};

AccountForm.propTypes = {
    formView: PropTypes.string.isRequired,
};

export default AccountForm;
